var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6202 0.630015C7.9402 0.310015 8.4501 0.310015 8.7701 0.630015C9.0801 0.940015 9.0801 1.46003 8.7701 1.77003L2.96004 7.57997H22.15C22.6 7.57997 22.96 7.94001 22.96 8.38001C22.96 8.83001 22.59 9.18995 22.15 9.18995H2.96004L8.7701 14.99C9.0801 15.31 9.0801 15.83 8.7701 16.14C8.4501 16.46 7.9402 16.46 7.6202 16.14L0.43001 8.94996C0.12001 8.63996 0.12001 8.12007 0.43001 7.81007L7.6202 0.630015Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.71fbf845afb358ca73e0e43c0e737b11.svg";
export { ForwardRef as ReactComponent };